import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import UserManagementModal from './modal/UserManagementModal';
import { UserManagementItemType } from '../../../api/userManagementApiTypes';
import { UserManagementFormType } from './modal/userManagementFormType';
import AmContractSignerModal from '../../common/modal/AmContractSignerModal';
import { AmContractSignerFormType } from '../../common/modal/AmContractSignerForm';
import AddViewerModal from '../../common/modal/AddViewerModal';
import { CONTRACT_SIGNER_ORIGIN, ApproverRoutingStatusType } from '../../../utils/Constants';

type UserManagementMenuProps = {
    routerProps: RouteComponentProps;
    personId: number;
    personName: string;
    userManagementItem: UserManagementItemType;
    onSubmit?: () => void;
    refresh: () => void;
};

const UserManagementMenu = (props: UserManagementMenuProps) => (
    <ul className="dropdown-menu dropdown-menu-right">
        <li>
            <button
                type="button"
                className="dropdown-menu-modal-toggle"
                onClick={() => {
                    props.routerProps.history.push({
                        pathname: `/details/${props.userManagementItem.amId}`,
                        state: {
                            returnPageName: 'Bulk User Management',
                            returnPathName: '/admin/userManagement',
                        },
                    });
                }}
            >
                <i className="far fa-info-circle button-icon" /> AM Details
            </button>
        </li>

        <li role="separator" className="dropdown-divider" />
        <li>
            <AddViewerModal
                title="Add Viewer"
                toggleButton={
                    <Button
                        variant="button"
                        className="dropdown-menu-modal-toggle dropdown-item"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        Add Viewer
                    </Button>
                }
                personId={props.personId}
                bulkSelectItems={[
                    {
                        amId: props.userManagementItem.amId,
                        amNumber: props.userManagementItem.amNumber,
                        supNumber: props.userManagementItem.supNumber,
                    },
                ]}
                onSubmit={props.refresh}
            />
        </li>
        {props.userManagementItem.replaceable && (
            <li>
                <UserManagementModal
                    title="Replace User"
                    toggleButton={
                        <Button
                            variant="button"
                            className="dropdown-menu-modal-toggle dropdown-item"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            Replace User
                        </Button>
                    }
                    formType={UserManagementFormType.REPLACE}
                    personId={props.personId}
                    personName={props.personName}
                    bulkSelectItems={[props.userManagementItem]}
                    onSubmit={props.refresh}
                />
            </li>
        )}
        {props.userManagementItem.removable && (
            <li>
                <UserManagementModal
                    title="Remove User"
                    toggleButton={
                        <Button
                            variant="button"
                            className="dropdown-menu-modal-toggle dropdown-item text-danger"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            Remove User
                        </Button>
                    }
                    formType={UserManagementFormType.REMOVE}
                    personId={props.personId}
                    personName={props.personName}
                    bulkSelectItems={[props.userManagementItem]}
                    onSubmit={props.refresh}
                />
            </li>
        )}
        {props.userManagementItem.routingStatus !== ApproverRoutingStatusType.APPROVED &&
            props.userManagementItem.routingStatus !== ApproverRoutingStatusType.SKIPPED &&
            props.userManagementItem.recordOrigin === CONTRACT_SIGNER_ORIGIN && (
                <li>
                    <AmContractSignerModal
                        title="Replace Contract Signer"
                        toggleButton={
                            <Button
                                variant="link"
                                className="dropdown-menu-modal-toggle dropdown-item"
                            >
                                Replace Contract Signer
                            </Button>
                        }
                        formType={AmContractSignerFormType.REPLACE}
                        amId={props.userManagementItem.amId}
                        contractSignerName={props.personName}
                        onSubmit={props.refresh}
                    />
                </li>
            )}
    </ul>
);

export default UserManagementMenu;
